import { render, staticRenderFns } from "./MyShopGoods.vue?vue&type=template&id=32678972"
import script from "./MyShopGoods.vue?vue&type=script&lang=js"
export * from "./MyShopGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports